import { render, staticRenderFns } from "./AmDataProfileIds.vue?vue&type=template&id=65bf146c&"
import script from "./AmDataProfileIds.vue?vue&type=script&lang=js&"
export * from "./AmDataProfileIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports